<template>
  <div class="d-flex flex-column justify-content-center align-items-center" style="gap: 5px" v-if="mapsMode">
    <MMP_LatLong
      :map="map"
      :mapsMode="mapsMode"
      :clickedCoords="clickedCoords"
      :selectedExtent="selectedExtent"
      @addPoint="$emit('addPoint', $event)"
    />
  </div>
</template>

<script>
import MMP_LatLong from './MMP_LatLong.vue';

export default {
  name: 'MMP_Tools',
  components: {
    MMP_LatLong
  },
  props: [
    'map',
    'mapsMode',
    'clickedCoords',
    'measurement',
    'showMeasuringTool',
    'selectedExtent'
  ]
};
</script>
